import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import openMenuIcon from '../../assets/images/openMenuIcon.svg';
import resetStore from '../../store/resetStore';
import { logoutThunk } from '../../store/slices/logoutSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { menuOptions } from '../../utils/constants';
import { getFirstAndLastName } from '../../utils/functions';
import styles from './styles/styles.module.css';

function UserMenuDropdown({ isDisabled }) {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);

  const user = useAppSelector((state) => state.user.data);
  const dispatch = useAppDispatch();

  const isLegalEntity = user?.type !== 'individual';
  const userName = isLegalEntity ? user?.company_name || '' : user?.full_name || '';
  const displayName = isLegalEntity ? userName : getFirstAndLastName(userName);

  const userSurname = user?.surname || '';
  const userPhone = user?.phone || '';

  const firstLetter =
    user?.type !== 'individual'
      ? user?.company_name
          ?.replace(/^(ООО|АО|ПАО|ЗАО|ОАО)\s*/i, '')
          .match(/[А-ЯЁA-Z]/i)?.[0]
          ?.toUpperCase() || 'Ю'
      : getFirstAndLastName(userName).charAt(0).toUpperCase();

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  console.log(userName, userSurname, user);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        closeMenu();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeMenu();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSelect = (value) => {
    closeMenu();
    if (value === 'logout') {
      dispatch(logoutThunk()).then(() => {
        dispatch(resetStore());
        navigate('/login');
      });
    } else {
      navigate(`/${value}`);
    }
  };
  console.log(user);
  return (
    <div
      className={`${styles.dropdownWrapper} ${isDisabled ? styles.disMenu : ''}`}
      ref={dropdownRef}
    >
      <button
        className={styles.userMenuButton}
        onClick={isDisabled ? () => {} : toggleMenu}
      >
        <div className={`${styles.userAvatar} ${isDisabled ? styles.dis : ''}`}>
          {firstLetter}
        </div>
        <div>
          <p className={styles.userName}>{displayName}</p>
          <p className={styles.userPhone}>{userPhone}</p>
        </div>
        <img
          className={`${styles.openMenuIcon} ${isOpen ? styles.openMenuIcon_active : ''}`}
          alt="иконка дальше"
          src={openMenuIcon}
        />
      </button>
      {isOpen && (
        <ul className={styles.dropdownMenu}>
          {menuOptions.map((option) => (
            <li key={option.value} className={styles.dropdownItem}>
              <button
                type="button"
                onClick={() => handleSelect(option.value)}
                className={styles.dropdownButton}
                onMouseEnter={() => setHoveredOption(option.value)}
                onMouseLeave={() => setHoveredOption(null)}
              >
                <img
                  src={hoveredOption === option.value ? option.activeIcon : option.icon}
                  alt="иконка опции меню"
                  className={styles.icon}
                />
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default UserMenuDropdown;
UserMenuDropdown.propTypes = {
  isDisabled: PropTypes.bool,
};
